// Display helpers for the user 💀 V4 views (mirror the Notification Lab helpers).
export const VERDICTS = {
  MARKET_MAKER: { emoji: '🐋', label: 'Market Maker', color: '#0284c7' },
  TEXTBOOK: { emoji: '✅', label: 'Textbook', color: '#16a34a' },
  WRONG_DIRECTION: { emoji: '❌', label: 'Wrong Direction', color: '#dc2626' },
  PERFECT_DETECTION_WRONG_DIR: { emoji: '🎯', label: 'Perfect Detection / Wrong Dir', color: '#7c3aed' },
  JUNK: { emoji: '🗑️', label: 'Junk / Spam', color: '#94a3b8' },
  STALLED: { emoji: '😴', label: 'Stalled (>50m consol.)', color: '#64748b' },
  INCONCLUSIVE: { emoji: '➖', label: 'Inconclusive', color: '#b45309' },
};

export const usd = (v) => (v === null || v === undefined ? '—' : `$${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`);
export const num = (v) => (v === null || v === undefined ? '—' : v);

export const sessionTag = (timestamp) => {
  const m = String(timestamp || '').match(/[T ](\d{2}):/);
  if (!m) return { emoji: '•', label: '—', color: '#94a3b8' };
  const hr = parseInt(m[1], 10);
  if (hr >= 7 && hr < 13) return { emoji: '🇬🇧', label: 'London', color: '#1d4ed8' };
  if (hr >= 13 && hr < 22) return { emoji: '🗽', label: 'NY', color: '#b45309' };
  return { emoji: '🌏', label: 'Tokyo', color: '#0d9488' };
};

const mt5Offset = (d) => {
  const y = d.getUTCFullYear();
  const firstSunMar = (7 - new Date(Date.UTC(y, 2, 1)).getUTCDay()) % 7;
  const dstStart = Date.UTC(y, 2, 1 + firstSunMar + 7, 7);
  const firstSunNov = (7 - new Date(Date.UTC(y, 10, 1)).getUTCDay()) % 7;
  const dstEnd = Date.UTC(y, 10, 1 + firstSunNov, 6);
  const t = d.getTime();
  return (t >= dstStart && t < dstEnd) ? 3 : 2;
};

export const mt5Time = (timestamp) => {
  if (!timestamp) return '—';
  let s = String(timestamp);
  if (s.indexOf('T') === -1) s = s.replace(' ', 'T');
  if (!/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) s += 'Z';
  const d = new Date(s);
  if (isNaN(d.getTime())) return String(timestamp).slice(5, 16).replace('T', ' ');
  const m = new Date(d.getTime() + mt5Offset(d) * 3600000);
  const p = (n) => String(n).padStart(2, '0');
  return `${p(m.getUTCMonth() + 1)}-${p(m.getUTCDate())} ${p(m.getUTCHours())}:${p(m.getUTCMinutes())}`;
};

export const rateColor = (rate) => (rate >= 85 ? '#16a34a' : rate >= 60 ? '#b45309' : '#dc2626');
